import { SYSTEM_TOAST_ERROR_MESSAGE, SYSTEM_TOAST_SUCCESS_MESSAGE, SYSTEM_TOAST_WARNING_MESSAGE, SYSTEM_TOAST_INFO_MESSAGE, SYSTEM_TOAST_CLEAR,SYSTEM_LINKS_MAIS_MANSERV } from '../actions/types';
import { INITIAL_STATE } from '../states/states';

export default (state = INITIAL_STATE.SYSTEM, action) => {
  switch (action.type) {
    case SYSTEM_TOAST_ERROR_MESSAGE:
      return { ...state, toast: { open: true, type: 'error', message: action.payload } };
    case SYSTEM_TOAST_SUCCESS_MESSAGE:
      return { ...state, toast: { open: true, type: 'success', message: action.payload } };
    case SYSTEM_TOAST_WARNING_MESSAGE:
      return { ...state, toast: { open: true, type: 'warning', message: action.payload } };
    case SYSTEM_TOAST_INFO_MESSAGE:
      return { ...state, toast: { open: true, type: 'info', message: action.payload } };
    case SYSTEM_TOAST_CLEAR:
      return { ...state, toast: { ...state.toast, open: false, message: '' } };
    case SYSTEM_LINKS_MAIS_MANSERV:
      return { ...state, linkMaisManserv: { ...state,linkMaisManserv: action.payload } };
    default:
      return state;
  }
};
